<template>
  <main class="container__brand">
    <div class="brand__header">
      <router-link to="/brandBalkam" class="go__back">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
      <img class="brand__logo" src="@/assets/img/brands/santos/santos.svg" alt="" />
      <img class="brand__bcg" src="@/assets/img/brands/santos/santos.svg" alt="" />
      <router-link to="/brandLavista" class="go__back__right">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
    </div>

    <div class="container__clm">
      <Carousell
        :images="[
          require('../../assets/img/brands/santos/p1.png'),
          require('../../assets/img/brands/santos/p2.png'),
          require('../../assets/img/brands/santos/p3.png'),
          require('../../assets/img/brands/santos/p4.png'),
          require('../../assets/img/brands/santos/p5.png'),
        ]"
      />
      <div class="brand__text">
        <div class="text">
          <!-- <h1>{{ $t('brands.santos.title') }}</h1> -->
          <p>{{ $t('brands.santos.desc') }}</p>
          <p>{{ $t('brands.santos.desc1') }}</p>
       
          <br />
          <p class="continets__text">{{ $t('brands.santos.title2') }}</p>
        </div>

        <div class="brand__continents">
          <img src="@/assets/img/brands/santos/map-santos.svg" alt="" />
        </div>
      </div>
    </div>
    <Button @click="redirect('https://coffeemall.bg/')" class="btn" type="button">{{ $t('buttons.button4') }}</Button>
  </main>
</template>


<script>
import Button from '@/components/Button';
import Carousell from '@/components/Carousell';
export default {
  components: {
    Button,
    Carousell,
  },
  data() {
    return {};
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/brands.scss';

.container__brand {
  background: #f7b90c 0% 0% no-repeat padding-box;
}
</style>